export default "__VITE_ASSET__h82Ld3Jz__"